'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkoutOffer = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doCheckoutOffer = doCheckoutOffer;
exports.watchOfferCheckout = watchOfferCheckout;

var _reactRouterRedux = require('react-router-redux');

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _location = require('containers/LocationModal/location.saga');

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doCheckoutOffer),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchOfferCheckout);

var CHECKOUT_OFFER = 'OFFER_CHECKOUT/CHECKOUT_OFFER';

var checkoutOffer = exports.checkoutOffer = function checkoutOffer(promotionAlias) {
  return { type: CHECKOUT_OFFER, promotionAlias: promotionAlias };
};

function doCheckoutOffer(client, _ref) {
  var promotionAlias = _ref.promotionAlias;

  var _ref2, msaId, _ref3, offers, _offers$reduce, msaOfferId;

  return _regenerator2.default.wrap(function doCheckoutOffer$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_location.getMsa, client);

        case 3:
          _ref2 = _context.sent;
          msaId = _ref2.id;
          _context.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.promotionByAlias, [client, promotionAlias, msaId]);

        case 7:
          _ref3 = _context.sent;
          offers = _ref3.offers;
          _offers$reduce = offers.reduce(function (bestOffer, currentOffer) {
            return currentOffer.offer.priority < bestOffer.offer.priority ? currentOffer : bestOffer;
          }, offers[0]), msaOfferId = _offers$reduce.id;
          _context.next = 12;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/signup/offer/' + _Base2.default.encode(msaOfferId)));

        case 12:
          _context.next = 16;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](0);

        case 16:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 14]]);
}

function watchOfferCheckout(client) {
  return _regenerator2.default.wrap(function watchOfferCheckout$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, CHECKOUT_OFFER, doCheckoutOffer, client);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}